import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Quote, BadgeCheck } from "lucide-react";
import { api, BACKEND_URL } from "@/lib/api";

const TAGS = { sponsor: "bg-blue-100 text-blue-800", vendor: "bg-emerald-100 text-emerald-800", beneficiary: "bg-amber-100 text-amber-800", partner: "bg-purple-100 text-purple-800" };
export const storyImg = (url) => (url && url.startsWith("/api") ? `${BACKEND_URL}${url}` : url);

const StoryCard = ({ s, i }) => {
  const navigate = useNavigate();
  const go = () => (s.cta_to.startsWith("#")
    ? document.getElementById(s.cta_to.slice(1))?.scrollIntoView({ behavior: "smooth" }) : navigate(s.cta_to));
  return (
    <article data-testid={`impact-story-${s.kind}-${i}`} className="group flex flex-col rounded-3xl bg-white border border-emerald-100 overflow-hidden shadow-sm hover:shadow-xl transition-shadow tmf-rise" style={{ animationDelay: `${i * 0.1}s` }}>
      <div className="relative h-60 overflow-hidden">
        <img src={storyImg(s.image_url)} alt={`${s.name}, ${s.role}`} className="w-full h-full object-cover object-[center_35%] transition-transform duration-700 group-hover:scale-105" />
        <span className={`absolute top-4 left-4 text-xs font-semibold px-3 py-1 rounded-full capitalize ${TAGS[s.kind] || TAGS.sponsor}`}>{s.kind} story</span>
      </div>
      <div className="flex flex-col flex-1 p-6">
        <div className="text-xs text-gray-500"><b className="text-emerald-950">{s.name}</b> · {s.role} · {s.place}</div>
        <h3 className="mt-3 font-display font-bold text-xl text-emerald-950 leading-snug">{s.title}</h3>
        <p className="mt-3 text-sm text-gray-600 leading-relaxed">{s.story}</p>
        <blockquote className="mt-4 relative rounded-2xl bg-emerald-50 p-4 pl-10 text-sm italic text-emerald-900 leading-relaxed">
          <Quote className="w-5 h-5 absolute left-3 top-4 text-emerald-400" />{s.quote}
        </blockquote>
        {s.impact && <p className="mt-4 flex items-center gap-2 text-sm font-semibold text-emerald-800" data-testid={`impact-story-impact-${i}`}><BadgeCheck className="w-4 h-4" />{s.impact}</p>}
        {s.cta_label && (
          <div className="mt-auto pt-6">
            <Button data-testid={`impact-story-cta-${i}`} onClick={go} className="rounded-full h-11 px-5 bg-emerald-700 hover:bg-emerald-800">
              {s.cta_label} <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </div>
        )}
      </div>
    </article>
  );
};

export const ImpactStories = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/impact-stories").then(({ data }) => setRows(data.stories)).catch(() => {}); }, []);
  if (!rows.length) return null;
  return (
    <section id="impact-stories" className="bg-[#f7faf8] border-y border-emerald-100" data-testid="impact-stories-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16 lg:py-24">
        <div className="max-w-3xl">
          <span className="text-xs font-mono uppercase tracking-widest text-emerald-700">Evidence of our impact</span>
          <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-emerald-950 tracking-tight">REAL PEOPLE. REAL IMPACT.</h2>
          <p className="mt-4 text-gray-600 text-base leading-relaxed">Every contribution, every transaction and every act of support has the potential to change a life. Discover how sponsors, local businesses and families can benefit through TEXT-ME-FOOD.</p>
        </div>
        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {rows.map((s, i) => <StoryCard key={s.id} s={s} i={i} />)}
        </div>
      </div>
    </section>
  );
};
